import { createContext, useContext, useCallback, useRef, useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

const ConfirmContext = createContext(null);

const DEFAULTS = {
  title: "Potwierdź zmianę",
  description: "Czy na pewno chcesz wykonać tę operację?",
  confirmText: "Potwierdź",
  cancelText: "Anuluj",
  danger: false,
};

export const ConfirmProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [opts, setOpts] = useState(DEFAULTS);
  const resolver = useRef(null);

  const confirm = useCallback((o = {}) => {
    setOpts({ ...DEFAULTS, ...o });
    setOpen(true);
    return new Promise((resolve) => { resolver.current = resolve; });
  }, []);

  const settle = (val) => {
    setOpen(false);
    if (resolver.current) { resolver.current(val); resolver.current = null; }
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AlertDialog open={open} onOpenChange={(v) => !v && settle(false)}>
        <AlertDialogContent data-testid="confirm-dialog" className="max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle data-testid="confirm-title" className="font-display uppercase tracking-wide">{opts.title}</AlertDialogTitle>
            <AlertDialogDescription data-testid="confirm-description" className="text-sm">{opts.description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="confirm-cancel" onClick={() => settle(false)}>{opts.cancelText}</AlertDialogCancel>
            <AlertDialogAction
              data-testid="confirm-ok"
              onClick={() => settle(true)}
              className={opts.danger
                ? "bg-rose-500 text-white hover:bg-rose-600 font-bold uppercase tracking-wider"
                : "bg-amber-400 text-[#0D1117] hover:bg-amber-500 font-bold uppercase tracking-wider"}
            >{opts.confirmText}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) return async () => true;
  return ctx;
};
